import React from "react";
import {cs} from "@common/react/chain-services";
import {consumeContext, provideContext} from "@common/react/context";
import {Load} from "@common/react/load";
import {Load2} from "@common/react/load2";
import {UseState} from "@common/react/use-state";
import {DsAddingSteps} from "./steps/ds-adding-steps";

export const loadDataFolders = ({next}) =>
    cs(
        consumeContext("apis"),
        [
            "folders",
            ({apis}, next) =>
                Load2({
                    fetch: () => apis.data.getFolders(),
                    next,
                }),
        ],
        ({folders}) => provideContext("dataSourceFolders", folders, next)
    );

export const AddDataSource = ({}) =>
    cs(
        consumeContext("routing"),
        consumeContext("apis"),
        (_, next) => loadDataFolders({next}),
        ["defaultDataSource", (_, next) => UseState({next})],
        [
            "dataSources",
            ({apis}, next) =>
                Load({
                    fetch: () => apis.data.getDataSources({namesOnly: true}),
                    next,
                }),
        ],
        [
            "initDataSource",
            ({routing, defaultDataSource}, next) => {
                // if(isDevSonPham()) {
                //     return next({"connectionDetails":{"originalFileName":"ExcelSample.xlsx","fileName":"637859007363311778-4800864.xlsx","extension":"xlsx","password":null,"$type":"FileConnectionDetails"},"type":"File","groupType":"files","$type":"FileConnectionDetails","name":"ExcelSample.xlsx","id":"8e1fc0e2-676d-4345-9c65-30ee7db02ade","tables":[{"name":"Expenses","tableReferenceName":"[excelsample].[2].[expenses]","schemaName":"excelsample","schemaReferenceName":"[excelsample]","records":38,"approxSyncSizeMB":0,"ctAvailable":false,"cdcAvailable":false,"columns":[{"name":"Month","columnReferenceName":"[excelsample].[2].[expenses].[month]","dataType":"Text","primaryKey":false,"indexed":false,"displayColumnReferenceName":"Month","dataTypeProperties":"NonPII"},{"name":"Expense","columnReferenceName":"[excelsample].[2].[expenses].[expense]","dataType":"Text","primaryKey":false,"indexed":false,"displayColumnReferenceName":"Expense","dataTypeProperties":"NonPII"},{"name":"Amount","columnReferenceName":"[excelsample].[2].[expenses].[amount]","dataType":"Double","primaryKey":false,"indexed":false,"displayColumnReferenceName":"Amount","dataTypeProperties":"None"}],"syncMethod":"Full","syncSchedule":{"$type":"OneTimeSync"},"disabledColumns":[]},{"name":"Leagues","tableReferenceName":"[excelsample].[1].[leagues]","schemaName":"excelsample","schemaReferenceName":"[excelsample]","records":34,"approxSyncSizeMB":0,"ctAvailable":false,"cdcAvailable":false,"columns":[{"name":"League","columnReferenceName":"[excelsample].[1].[leagues].[league]","dataType":"Int","primaryKey":false,"indexed":false,"displayColumnReferenceName":"League","dataTypeProperties":"None"},{"name":"LeagueName","columnReferenceName":"[excelsample].[1].[leagues].[leaguename]","dataType":"Text","primaryKey":false,"indexed":false,"displayColumnReferenceName":"LeagueName","dataTypeProperties":"NonPII"},{"name":"LeageAbbr","columnReferenceName":"[excelsample].[1].[leagues].[leageabbr]","dataType":"Text","primaryKey":false,"indexed":false,"displayColumnReferenceName":"LeageAbbr","dataTypeProperties":"NonPII"}],"syncMethod":"Full","syncSchedule":{"$type":"OneTimeSync"},"disabledColumns":[]}],"disabledTables":[]})
                // }

                const defaultSelected = routing.params.defaultDataSource;
                const defaultConfig = {
                    file: {
                        type: "File",
                        groupType: "files",
                        $type: `FileConnectionDetails`,
                    },
                };

                return next({
                    connectionDetails: {},
                    ...(defaultConfig[defaultSelected] ?? {}),
                });
            },
        ],

        [
            "dataSource",
            ({initDataSource}, next) =>
                UseState({
                    initValue: {
                        ...initDataSource,
                        folderID: null,
                        structured: true,
                    },
                    next,
                }),
        ],

        ({dataSource, dataSources}) => {
            return <>{DsAddingSteps({dataSource, dataSourceList: dataSources})}</>;
        }
    );
